import React from 'react';
import Svg from '../Svg';

const IconCoins04 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.40112 3.28576C10.843 1.87283 12.8206 1 15 1C19.4183 1 23 4.58172 23 9C23 11.1795 22.1271 13.1571 20.7142 14.599C20.3276 14.9934 19.6945 14.9998 19.3 14.6133C18.9056 14.2267 18.8992 13.5936 19.2857 13.1991C20.3472 12.1159 21 10.6352 21 9C21 5.68629 18.3137 3 15 3C13.3648 3 11.8841 3.65279 10.8009 4.71424C10.4065 5.10079 9.77332 5.09436 9.38678 4.6999C9.00023 4.30544 9.00665 3.6723 9.40112 3.28576ZM9 9C5.68629 9 3 11.6863 3 15C3 18.3137 5.68629 21 9 21C12.3137 21 15 18.3137 15 15C15 11.6863 12.3137 9 9 9ZM1 15C1 10.5817 4.58172 7 9 7C13.4183 7 17 10.5817 17 15C17 19.4183 13.4183 23 9 23C4.58172 23 1 19.4183 1 15ZM9.47186 11.1183C9.79702 11.2923 10 11.6312 10 12V16.5H10.5C11.0523 16.5 11.5 16.9477 11.5 17.5C11.5 18.0523 11.0523 18.5 10.5 18.5H7.5C6.94772 18.5 6.5 18.0523 6.5 17.5C6.5 16.9477 6.94772 16.5 7.5 16.5H8V13.8661C7.54703 14.1282 6.96231 13.9962 6.66795 13.5547C6.3616 13.0952 6.48577 12.4743 6.9453 12.1679L8.4453 11.1679C8.75216 10.9634 9.1467 10.9443 9.47186 11.1183Z"
    />
  </Svg>
);

export default IconCoins04;
